const $alerts = $('#flashMessages');

export class Alert {
  static error(message) {
    this.show('error', message);
  }

  static warning(message) {
    this.show('warning', message);
  }

  static success(message) {
    this.show('success', message);
  }

  static notice(message) {
    this.show('notice', message);
  }

  static show(type, message) {
    let alert_class = null;
    if (type === 'error') {
      alert_class = 'alert-danger';
    }
    else if (type === 'warning') {
      alert_class = 'alert-warning';
    }
    else if (type === 'notice') {
      alert_class = 'alert-info';
    }
    else if (type === 'success') {
      alert_class = 'alert-success';
    }
    else {
      throw new Error(`Alert: unknown alert type "${type}".`);
    }

    if (message === undefined || message == null || message === '') {
      throw new Error('Alert: missing message');
    }

    const $element = $(`<div class="alert ${alert_class} alert-dismissible fade show">`);
    $element.append(message);

    const $button = $('<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Schließen">');
    $element.append($button);

    $alerts.append($element);
  }
}
